export const EQUALITY_OPERATORS = ["$eq", "$ne", "$in", "$nin"] as const;
export const ORDER_OPERATORS = ["$eq", "$ne", "$gt", "$gte", "$lt", "$lte"] as const;
export const SET_OPERATORS = ["$any", "$all"] as const;

export type EqualityOperator = (typeof EQUALITY_OPERATORS)[number];
export type OrderOperator = (typeof ORDER_OPERATORS)[number];
export type SetOperator = (typeof SET_OPERATORS)[number];
export type FilterTreeOperator = EqualityOperator | OrderOperator | SetOperator;

const ALL_OPERATORS: readonly string[] = [
  ...EQUALITY_OPERATORS,
  ...ORDER_OPERATORS,
  ...SET_OPERATORS,
];

export const isFilterOperator = (key: string): key is FilterTreeOperator =>
  ALL_OPERATORS.includes(key);
